export class UIController {
  constructor(store) {
    this.store = store;
  }

  get headerActive() {
    return this.store.state.ui.headerActive;
  }

  set headerActive(value) {
    this.store.commit('ui/SET', { key: 'headerActive', value });
  }
}

export default ({ store }, inject) => {
  store.registerModule(
    'ui',
    {
      namespaced: true,
      state: () => ({
        headerActive: false,
      }),
      mutations: {
        SET(state, { key, value }) {
          if (key in state) state[key] = value;
        },
      },
    },
    { preserveState: process.browser && !process.env.SPA }
  );

  inject('ui', new UIController(store));
};
